<button mat-icon-button (click)="openNotificationTray()" class="custom-badge-button">
    <mat-icon>notifications</mat-icon>
    <span *ngIf="unreadNotifications > 0"
          class="animate-bounce absolute top-0 right-0 text-sm bg-red-400 rounded-full text-white px-2 py-1">{{ unreadNotifications }}</span>
</button>
